import Element from 'element-ui'
import '../theme/index.scss'

export default function(Vue){
  Vue.use(Element)
}
